import { useData } from '@hooks/useData';
import http from '@core/fetch';
import apiConfig from '@apiConfig';
import { components } from '@apiSchema';

export type SavedSearchItem = components['schemas']['SavedSearchItem'];
type SavedSearchesResponse = components['schemas']['SavedSearchesResponse'];

interface SavedSearchesData {
    personal: SavedSearchItem[];
    companyOwned: SavedSearchItem[];
}

const REQUEST_TYPE: keyof typeof apiConfig = 'get independents saved searches';

const DEFAULT_DATA: SavedSearchesData = { personal: [], companyOwned: [] };

async function getSavedSearches(): Promise<SavedSearchesData> {
    const response = await http.get(REQUEST_TYPE) as SavedSearchesResponse;
    return {
        personal: response?.personal ?? [],
        companyOwned: response?.companyOwned ?? [],
    };
}

export function useIndependentsSavedSearches() {
    return useData(DEFAULT_DATA, getSavedSearches);
}
